import { createContext, useContext, useEffect, useRef, useState } from "react";

const WebSocketContext = createContext();

export const WebSocketProvider = ({children})=>{

    const socketRef = useRef(null);

    const[socket,setSocket] = useState(null);
    const[walletData,setWalletData]=useState(null);
    const[dashboardStatus,setDashboardStatus]=useState(null);
    
    const[token,setToken]=useState(JSON.parse(localStorage.getItem('accessToken')))

    const connectWebSocket=(newToken)=>{
        setToken(newToken)
    }

    useEffect(()=>{

        console.log("token in socket",token)
        if (!token){
            return;
        }

        const protocol = window.location.protocol === "https:" ? "wss:" : "ws:"
        const wsHost = process.env.NODE_ENV === 'development' ? 'localhost:8000' : window.location.host;
        const ws = new WebSocket(
            `${protocol}//${wsHost}/ws/realtime/?token=${token}`
        )

        socketRef.current = ws;

        ws.onopen=()=>{
            console.log("Websocket connected")
        }
        
        ws.onmessage=(event)=>{
            const parsedData = JSON.parse(event.data);

            console.log("socket event",parsedData);

            switch(parsedData.event){
                case "wallet.updated":
                    setWalletData(parsedData.data);
                    break;
                case "dashboard.updated":
                    setDashboardStatus(parsedData.data);
                    break;
                default:
                    console.log("Unhandled event",parsedData)
            }
        }

        ws.onclose=()=>{
            console.log("Websocket Disconnected")
        }

        ws.onerror=(error)=>{
            console.log("Websocket error",error)
        }

        setSocket(ws);

        return ()=> {
            ws.close();
        }

    },[token])

    return(
        <WebSocketContext.Provider
            value={{
                socket:socketRef.current,
                walletData,
                dashboardStatus,
                connectWebSocket
            }}
        >
            {children}
        </WebSocketContext.Provider>
    )
}

export const useWebSocket=()=>{
    return useContext(WebSocketContext);
}